module.exports = __webpack_public_path__ + "img/2.e156f6aa.png";